import cn from 'classnames';
import React from 'react';
import { useDispatch } from 'react-redux';

import { setSearchText } from '../../../../store/actions/supplierInventory';
import useDebouncedValue from '../../../../hooks/useDebouncedValue';

import styles from './styles.module.scss';

export function SearchInventory() {
  const dispatch = useDispatch();
  const [inputValue, setInputValue] = React.useState('');
  const debouncedValue = useDebouncedValue(inputValue, 300);

  React.useEffect(() => {
    dispatch(setSearchText(debouncedValue));
    // eslint-disable-next-line
  }, [debouncedValue]);

  return (
    <div className={styles.container}>
      <div className={styles.title}>Search Inventory</div>
      <div className={cn('search', styles.search)}></div>
      <input
        type="text"
        value={inputValue}
        placeholder="Search"
        onChange={(event) => setInputValue(event.target.value)}
      />
      <div className="ic-search" />
    </div>
  );
}
